var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M-2-2h24v24H-2V-2z","key":0}),React.createElement("path",{"d":"M10,0C4.4772,0,0,4.4772,0,10s4.4772,10,10,10s10-4.4772,10-10S15.5228,0,10,0z M9,17.93\n\tC5.0001,17.4314,1.9983,14.0309,2,10c0.0033-0.6026,0.0738-1.203,0.21-1.79L7,13v1c0.0033,1.1032,0.8968,1.9967,2,2V17.93z\n\t M15.9,15.39c-0.2603-0.8296-1.0305-1.3931-1.9-1.39h-1v-3c0-0.5523-0.4477-1-1-1H6V8h2c0.5523,0,1-0.4477,1-1V5h2\n\tc1.1032-0.0033,1.9967-0.8968,2-2V2.59c4.0892,1.6469,6.0691,6.2968,4.4222,10.386C17.0639,13.8656,16.5483,14.6833,15.9,15.39z","key":1})]);
}

Globe.defaultProps = {"focusable":"false","viewBox":"0 0 20 20"};

module.exports = Globe;

Globe.default = Globe;
